import React, { useEffect } from 'react';
import {
  Box,
  constants,
  Center,
  DefaultPageTemplate,
  PeriscopeDashboardIframe,
  util,
  Title,
} from '@thecb/components';
import AlertBar from '../../components/alert-bar';
import { useDispatch, useSelector } from 'react-redux';
import {
  periscopeDataRequestFailure,
  periscopeDataRequestSuccess,
  requestPeriscopeDashboardIframe,
} from './Reporting.state';

const Header = ({ alertBar, alertBarActions }) => (
  <Box width="100%" padding="16px 0">
    <Center maxWidth="85.714rem">
      {alertBar.alerts.length > 0 && (
        <Box padding="16px 0">
          <AlertBar {...alertBar} {...alertBarActions} />
        </Box>
      )}
      <Title
        color={constants.colors.CHARADE_GREY}
        weight={constants.fontWeights.FONT_WEIGHT_BOLD}
      >
        Reporting
      </Title>
    </Center>
  </Box>
);

const Reporting = ({ actions }) => {
  const {
    url,
    periscopeDataPending,
    periscopeDataSuccess,
    periscopeDataFailure,
    alertBars,
  } = useSelector((state) => state.reporting);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(requestPeriscopeDashboardIframe());
  }, []);

  const content = (
    <PeriscopeDashboardIframe
      url={url}
      requestDashboardUrl={() => util.general.noop} // noop because we handle this request in useEffect
      periscopeDataPending={periscopeDataPending}
      periscopeDataSuccess={periscopeDataSuccess}
      periscopeDataFailure={periscopeDataFailure}
      periscopeDataRequestSuccess={() =>
        dispatch(periscopeDataRequestSuccess())
      }
      periscopeDataRequestFailure={() =>
        dispatch(periscopeDataRequestFailure())
      }
    />
  );

  return (
    <DefaultPageTemplate
      header={
        <Header
          key="ReportingHeader"
          alertBar={alertBars.reportingAlertBars}
          alertBarActions={actions.alertBars.reportingAlertBars}
        />
      }
      content={content}
      gutters="0"
      maxWidth="85.714rem"
    />
  );
};

export default Reporting;
